import React, { useState } from 'react';
import ChevronDownSolid from '@bitcoin-portal/bitcoincom-pkg-components/dist/IconsNavigation/ChevronDownSolid';
import ChevronUpSolid from '@bitcoin-portal/bitcoincom-pkg-components/dist/IconsNavigation/ChevronUpSolid';
import { colors } from '@bitcoin-portal/bitcoincom-pkg-theme';
import { Sublink, SubmenuWrapper, Overlay } from './styled';
import { SubmenuHeader, Wrapper, Link } from '../styled';
const Links = ({ contrast = false, links }) => {
    const [currentSection, setCurrentSection] = useState('');
    const [close, setClose] = useState(true);
    const handleClick = (id) => {
        if (currentSection === id && close) {
            setClose(false);
            setCurrentSection('');
        }
        else if (currentSection === id && !close) {
            setCurrentSection('');
            setClose(true);
        }
        else {
            setCurrentSection(id);
            setClose(false);
        }
    };
    return (React.createElement(Wrapper, { isMobile: true, contrast: contrast }, links.map(({ id, link, sublinks = [] }) => {
        if (link) {
            return (React.createElement(Link, { key: id, href: link, className: "universal-menu-link", rel: "canonical", contrast: contrast },
                React.createElement("span", { style: { display: 'flex', alignItems: 'center' } }, id)));
        }
        return (React.createElement(SubmenuHeader, { contrast: contrast, className: "universal-menu-link", onClick: () => {
                handleClick(id);
            } },
            React.createElement("span", { style: { display: 'flex', alignItems: 'center' } },
                id,
                currentSection === id ? (React.createElement(ChevronUpSolid, { size: 14, color: contrast ? colors.solid.white : colors.solid.textOne })) : (React.createElement(ChevronDownSolid, { size: 14, color: contrast ? colors.solid.white : colors.solid.textOne }))),
            currentSection === id && !close && (React.createElement(React.Fragment, null,
                React.createElement(Overlay, { onClick: () => handleClick(id) }),
                React.createElement(SubmenuWrapper, null, sublinks.map(({ id: sublinkId, url }) => {
                    return (React.createElement(Sublink, { key: sublinkId, href: url, contrast: contrast, className: "universal-menu-link sublink", rel: "canonical" },
                        React.createElement("span", null, sublinkId)));
                }))))));
    })));
};
export default Links;
//# sourceMappingURL=MobileLinks.js.map